export enum BadgeType {
  Urgent = 'badge-urgent',
  Default = 'badge-default',
  Issue = 'badge-issue',
  Normal = 'badge-normal',
  Primary = 'badge-primary',
  Important = 'badge-important',
}
